<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer001">
<p class="ORIM-Book-Title--Front-Matter-">Ulysses</p>
<p class="ORIM-Author-Name--Front-Matter-">James Joyce</p>
<p class="ORIM-Author-Name--Front-Matter-"><a><img alt="" src="logo2.jpg" style=""/></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?c95930b6